import React from 'react';
import { space, radius } from '../tokens';
import { statusChipConfig } from '../icons';

const StatusChipStrip = ({ chips = [], size = 'md' }) => {
  if (!chips.length) return null;

  const padY = size === 'sm' ? 2 : 3;
  const padX = size === 'sm' ? 8 : 10;
  const fontSize = size === 'sm' ? 11 : 12;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: space[2] }}>
      {chips.map(key => {
        const cfg = statusChipConfig[key];
        if (!cfg) return null;
        return (
          <span
            key={key}
            title={cfg.label}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              background: cfg.bg,
              color: cfg.fg,
              padding: `${padY}px ${padX}px`,
              borderRadius: radius.pill,
              fontSize,
              fontWeight: 600,
              lineHeight: 1.3,
              whiteSpace: 'nowrap',
              letterSpacing: 0.1,
            }}
          >
            {cfg.label}
          </span>
        );
      })}
    </div>
  );
};

export default StatusChipStrip;
